import { isBefore } from "date-fns";
import { useDispatch, useSelector } from "react-redux";

import {
  AgentActions,
  IAgentFlags,
  IWithAgentsSessionState,
  selectAgentFlagByName,
  selectLoggedInAgent,
} from "store/entities/agents";

interface IUseNewFeatureForAgents {
  isNewForAgent: boolean;
  featureFlagValue: boolean;
  setAgentFlagCallback: () => void;
}

export function useNewFeatureForAgents(featureFlagName: string, campaignStartDate: string): IUseNewFeatureForAgents {
  const dispatch = useDispatch();

  const agent = useSelector(selectLoggedInAgent);
  const featureFlagValue = useSelector(state =>
    selectAgentFlagByName(state as IWithAgentsSessionState, featureFlagName.split("_")[0] as keyof IAgentFlags)
  );

  const isNewForAgent = isBefore(agent.createdAt, campaignStartDate);

  const setAgentFlagCallback = (): void => {
    if (featureFlagValue) return;

    dispatch(AgentActions.setFlag({ name: featureFlagName, value: true }));
  };

  return {
    isNewForAgent,
    featureFlagValue,
    setAgentFlagCallback,
  };
}
